const styles = {
    floatingButton: {
        position: 'fixed',
        zIndex: 1000,
        right: 20,
        bottom: 30
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: '100%'
    },
    loader: {
        display: 'inline-block',
        position: 'absolute',
        zIndex: 1000,
        top: 90,
        right: 15,
        left: 'unset',
        transform: 'unset'
    },
    list: {
        container: {
            position: 'relative',
            padding: '90px 17px 85px 17px'
        },
        bottomNavigationBar: {
            position: 'fixed',
            zIndex: 1000,
            width: '100%',
            bottom: 0,
            left: 0,
            right: 0
        }
    },
    toolBar: {
        container: {
            position: 'absolute',
            top: 11,
            height: '62px',
            zIndex: 1000,
            backgroundColor: 'white',
            border: '2px solid rgba(0,0,0,0.2)',
            backgroundClip: 'padding-box',
            borderRadius: '4px'
        },
        containerMap: {
            width: 'calc(100% - 75px)',
            left: 60
        },
        containerList: {
            width: 'calc(100% - 30px)',
            left: 15
        },
        searchBar: {
            width: '90%'
        },
        checkBox: {
            container: {
                paddingLeft: 30,
                position: 'relative',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            item: {
                width: '100px'
            }
        }
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/report/Reports/Reports.css.js